export const NO_CACHE = 0; // expires immediately, set as the default for any requests using axiosHelper methods with a cache
export const ONE_SECOND_SESSION = 1000;
export const SHORT_SESSION = 5 * 60 * 1000; // 5 minutes
export const MEDIUM_SESSION = 15 * 60 * 1000; // 15 minutes
export const LONG_SESSION = 60 * 60 * 1000; // 1 hour
export const IMMUTABLE = 60 * 24 * 60 * 1000; // 24 hours
